import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustSection from "./components/TrustSection";
import CategoriesSection from "./components/CategoriesSection";
import ProductsSection from "./components/ProductsSection";
import SafetySection from "./components/SafetySection";
import ComparisonSection from "./components/ComparisonSection";
import ArticlesSection from "./components/ArticlesSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://hoobuy.monster";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main>
        <article>
          <HeroSection />
          <TrustSection />
          <CategoriesSection />
          <ProductsSection />
          <SafetySection />
          <ComparisonSection />
          <ArticlesSection />
          <FAQSection />
          <CTASection />
        </article>
      </main>

      <Footer />

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Hoobuy Spreadsheet",
            url: siteUrl,
            logo: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/879fae149d7d175a673508cd1be74143.jpeg",
            description: "A maior Hoobuy Spreadsheet em português com links atualizados diariamente. Mais de 5.000 produtos organizados com vendedores verificados.",
            sameAs: [
              "https://kaspreadsheet.com",
            ],
          }),
        }}
      />

      {/* WebPage Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Hoobuy Spreadsheet 2026: Os Melhores Links, Sneakers e Produtos Atualizados",
            description: "Descubra a maior Hoobuy Spreadsheet em português com sneakers, roupas, bolsas e links atualizados diariamente.",
            url: siteUrl,
            inLanguage: "pt-BR",
            isPartOf: {
              "@type": "WebSite",
              name: "Hoobuy Spreadsheet",
              url: siteUrl,
            },
          }),
        }}
      />
    </div>
  );
}